// Catalog complet — Produse Alimentare En Gross
// Categorii: Marinate, Legume conservate, Conserve, Biscuiți, Fursecuri, Cornulețe,
// Turtă dulce, Bomboane, Caramele, Halva, Zefir, Vafe, Torturi, Prăjituri, Chec,
// Croissant, Pliculețe, Nuci, Jeleuri, Cadou, Vin spumant, Vin alb, Vin roșu, Vin rosé, Desert

// Tiles extrase din catalogul PDF al clientului (spread 01-23 × 4 col × 2 row)
// Skip spread 00 (cover) — restul oferă 184 tiles pentru ~134 produse.
const tileFor = (i) => {
  const spread = 1 + Math.floor(i / 8); // 1..23
  const cell = i % 8;
  const row = Math.floor(cell / 4);
  const col = cell % 4;
  return `/products/tiles/tile_${String(spread).padStart(2, "0")}_${row}${col}.jpg`;
};

const raw = [
  { name: "Ardei iuți marinați", category: "Marinată", size: "430 ml", pack: "6/bax" },
  { name: "Castraveți marinați în oțet 6–9 cm", category: "Marinată", size: "720 ml", pack: "8/bax" },
  { name: "Asorti castraveți–tomate", category: "Marinată", size: "720 ml", pack: "8/bax" },
  { name: "Castraveți marinați în saramură", category: "Marinată", size: "900 ml", pack: "8/bax" },
  { name: "Gogoșari marinați", category: "Marinată", size: "430 ml", pack: "6/bax" },

  { name: "Fasole în sos de tomate", category: "Legume conservate", size: "430 ml", pack: "6/bax" },
  { name: "Fasole naturală", category: "Legume conservate", size: "430 ml", pack: "6/bax" },
  { name: "Mazăre verde conservată", category: "Legume conservate", size: "450 g", pack: "6/bax" },
  { name: "Porumb dulce conservat", category: "Legume conservate", size: "425 ml", pack: "12/bax" },
  { name: "Pastă de tomate", category: "Conserve", size: "370 g", pack: "8/bax" },

  { name: "Biscuiți Mix asortat nr. 1", category: "Biscuiți", size: "200 g" },
  { name: "Fursecuri Urechiușe", category: "Biscuiți", size: "350 g", pack: "cutie" },
  { name: "Biscuiți Fiesta Shoko", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți Limosha", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți fărâmicioși Vișneve", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți Solodka Dolyna — Aricel cu cocos", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți Country cu gust de lapte fiert", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți cu cocos", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți Carot Mix", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți cu porumb", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți Morning", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți Fransua cu gust de ciocolată", category: "Biscuiți", size: "400 g" },
  { name: "Biscuiți Smorodinka — umplutură mere și coacăze", category: "Biscuiți", size: "430 g" },
  { name: "Fursecuri Umbra Soarelui", category: "Fursecuri", size: "450 g", pack: "cutie" },
  { name: "Mix asortat nr. 4", category: "Biscuiți", size: "450 g" },
  { name: "Biscuiți Milașca", category: "Biscuiți", size: "450 g / 5,5 kg (vrac)" },
  { name: "Mix asortat nr. 3", category: "Biscuiți", size: "500 g" },
  { name: "Biscuiți shortbread Caisă", category: "Biscuiți", size: "500 g" },
  { name: "Biscuiți Favoriți", category: "Biscuiți", size: "500 g" },
  { name: "Fursecuri mix nr. 3 Toniya", category: "Fursecuri", size: "500 g", pack: "cutie" },
  { name: "Fursecuri mix nr. 5 Toniya", category: "Fursecuri", size: "500 g", pack: "cutie" },
  { name: "Fursecuri Deliciu", category: "Fursecuri", size: "500 g", pack: "cutie" },
  { name: "Fursecuri Ștrudel", category: "Fursecuri", size: "500 g", pack: "cutie" },
  { name: "Fursecuri Frutti Choice Enjoy", category: "Fursecuri", size: "500 g", pack: "cutie" },
  { name: "Biscuiți Galiția cu jeleu de portocale", category: "Biscuiți", size: "500 g" },
  { name: "Biscuiți Galiția cu jeleu de vișine", category: "Biscuiți", size: "500 g" },
  { name: "Biscuiți Meteorit", category: "Biscuiți", size: "500 g" },
  { name: "Turtă dulce Prințul Negru", category: "Turtă dulce", size: "500 g" },
  { name: "Turtă dulce Prințul Alb", category: "Turtă dulce", size: "500 g" },
  { name: "Americano cu stafide", category: "Biscuiți", size: "600 g" },
  { name: "Americano cu ciocolată", category: "Biscuiți", size: "600 g" },
  { name: "Mix asortat nr. 2", category: "Biscuiți", size: "600 g" },
  { name: "Biscuiți clasici — umplutură caise", category: "Biscuiți", size: "600 g" },
  { name: "Fursecuri cu cereale", category: "Fursecuri", size: "610 g" },

  { name: "Cornulețe caramel", category: "Cornulețe", size: "600 g" },
  { name: "Cornulețe Duo", category: "Cornulețe", size: "800 g" },
  { name: "Cornulețe cu lapte topit și gem", category: "Cornulețe", size: "800 g" },

  { name: "Fursecuri Zmeurica Bunicica — glazură albă", category: "Fursecuri", size: "700 g" },
  { name: "Fursecuri Zmeurica Bunicica — glazură cacao", category: "Fursecuri", size: "700 g" },
  { name: "Fursecuri Miracol cu gem de lămâie", category: "Fursecuri", size: "700 g" },
  { name: "Fursecuri asortate nr. 6", category: "Fursecuri", size: "800 g" },
  { name: "Fursecuri Ursuleț", category: "Fursecuri", size: "800 g", pack: "cutie" },
  { name: "Fursecuri Sparja", category: "Fursecuri", size: "800 g" },
  { name: "Biscuiți cu mac — DE POST", category: "Biscuiți", size: "900 g" },

  { name: "Fursecuri Delicia cu Vișină", category: "Fursecuri", size: "1 kg", pack: "cutie" },
  { name: "Fursecuri Delicia cu vișină și glazură de lapte", category: "Fursecuri", size: "1 kg", pack: "cutie" },
  { name: "Fursecuri Super Monica", category: "Fursecuri", size: "1,2 kg", pack: "cutie" },
  { name: "Pliculețe cu coacăze negre", category: "Pliculețe", size: "1 kg" },
  { name: "Pliculețe cu caise", category: "Pliculețe", size: "1 kg" },
  { name: "Nuci pudrate", category: "Nuci", size: "1 kg" },
  { name: "Pliculețe Limoncelo", category: "Pliculețe", size: "1 kg" },
  { name: "Fursecuri Nuci", category: "Fursecuri", size: "1 kg", pack: "cutie" },
  { name: "Fursecuri asortate de sărbători nr. 1", category: "Fursecuri", size: "1 kg" },
  { name: "Biscuiți Cocos (A)", category: "Biscuiți", size: "1 kg" },
  { name: "Biscuiți belgieni cu lapte condensat", category: "Biscuiți", size: "1,1 kg" },
  { name: "Zefir glazurat Jako", category: "Zefir", size: "1 kg" },
  { name: "Fursecuri Royal", category: "Fursecuri", size: "1 kg" },
  { name: "Mazutca", category: "Prăjituri", size: "1 kg" },
  { name: "Tort vafe Bounty", category: "Torturi", size: "1,2 kg" },
  { name: "Ciupercuțe umplute cu caramel", category: "Prăjituri", size: "1,3 kg" },
  { name: "Prăjitură cu vafe asortate", category: "Prăjituri", size: "1,5 kg" },
  { name: "Tort vafe Veveriță", category: "Torturi", size: "1,5 kg" },
  { name: "Tub vafe Irisca", category: "Vafe", size: "1,5 kg" },
  { name: "Tub vafe Pombir", category: "Vafe", size: "1,5 kg" },
  { name: "Tub vafe Banana", category: "Vafe", size: "1,5 kg" },
  { name: "Chec desert cu ciocolată", category: "Chec", size: "1,8 kg" },
  { name: "Zefir Smile cu umplutură de afine", category: "Zefir", size: "2,2 kg (44 × 50 g)" },
  { name: "Zefir Smile cu umplutură de zmeură", category: "Zefir", size: "2,2 kg (44 × 50 g)" },
  { name: "Zefir Smile cu lapte condensat", category: "Zefir", size: "2,2 kg (44 × 50 g)" },
  { name: "Bomboane Plombirini", category: "Bomboane", size: "2,5 kg" },
  { name: "Lapte pasăre Jako", category: "Desert", size: "2,7 kg" },
  { name: "Bomboane glazurate Smakyrok", category: "Bomboane", size: "3 kg" },

  { name: "Jeleuri Zmeurica", category: "Jeleuri", size: "450 g" },
  { name: "Jeleuri Viermișori", category: "Jeleuri", size: "500 g" },

  { name: "Croissant Lukas cu caise", category: "Croissant", size: "1,44 kg", pack: "cutie" },
  { name: "Croissant Lukas cu căpșuni", category: "Croissant", size: "1,44 kg", pack: "cutie" },
  { name: "Croissant Lukas cu vișine", category: "Croissant", size: "1,44 kg", pack: "cutie" },
  { name: "Croissant Lukas cu ciocolată", category: "Croissant", size: "1,44 kg", pack: "cutie" },

  { name: "Halva „Victorița\" stafide", category: "Halva", size: "350 g" },
  { name: "Halva „Victorița\" stafide", category: "Halva", size: "180 g" },
  { name: "Halva „Victorița\" arahide", category: "Halva", size: "350 g" },
  { name: "Halva „Victorița\" arahide", category: "Halva", size: "180 g" },
  { name: "Halva „Victorița\" arahide", category: "Halva", size: "30 g" },
  { name: "Halva „Victorița\" vanilie", category: "Halva", size: "350 g" },
  { name: "Halva „Victorița\" vanilie", category: "Halva", size: "180 g" },
  { name: "Halva „Victorița\" vanilie", category: "Halva", size: "30 g" },
  { name: "Halva „Victorița\" cacao", category: "Halva", size: "350 g" },
  { name: "Halva „Victorița\" cacao", category: "Halva", size: "180 g" },
  { name: "Halva „Victorița\" cacao", category: "Halva", size: "30 g" },

  { name: "Caramele „Frutic\" asort", category: "Caramele", size: "190 g / 1 kg" },
  { name: "Bomboane „Gloria — Caprice Asorti\"", category: "Bomboane", size: "250 g / 1 kg" },
  { name: "Bomboane „Clepsidra\"", category: "Bomboane", size: "250 g / 1 kg" },
  { name: "Bomboane „Inspirație\" cu gust de Caise", category: "Bomboane", size: "250 g / 1 kg" },
  { name: "Bomboane Inspirație cu gust de lămâie", category: "Bomboane", size: "250 g" },
  { name: "Bomboane „Inspirație\" cu gust de Portocală", category: "Bomboane", size: "250 g / 1 kg" },
  { name: "Bomboane „Inspirație\" cu gust de Vișină", category: "Bomboane", size: "250 g / 1 kg" },
  { name: "Bomboane „Pasărea Măiastră\" frișcă", category: "Bomboane", size: "150 g" },
  { name: "Bomboane Masca", category: "Bomboane", size: "250 g" },
  { name: "Bomboane „Chișinăul de Seară\"", category: "Bomboane", size: "250 g / 1 kg" },
  { name: "Bomboane „Valurile Mării\"", category: "Bomboane", size: "1 kg" },
  { name: "Bomboane „Lămâița\"", category: "Bomboane", size: "1 kg" },
  { name: "Bomboane „Originale\"", category: "Bomboane", size: "1 kg" },
  { name: "Caramele Răcușori — umplute cu ciocolată și arahide (DE POST)", category: "Caramele", size: "190 g / 1 kg" },
  { name: "Bomboane Scufița Roșie", category: "Bomboane", size: "2,3 kg" },
  { name: "Bomboane Griliaj", category: "Bomboane", size: "3 kg" },
  { name: "Bomboane Victorița", category: "Bomboane", size: "3 kg" },
  { name: "Bomboane „Coșuleț cu Cireșe\"", category: "Bomboane", size: "200 g", pack: "12/cutie" },
  { name: "Bomboane „Coșuleț cu Prune\"", category: "Bomboane", size: "200 g", pack: "12/cutie" },
  { name: "Bomboane „Coșuleț cu Caise\"", category: "Bomboane", size: "200 g", pack: "12/cutie" },

  { name: "Cadou Punguța de Crăciun", category: "Cadou", size: "100 g" },
  { name: "Cadou La Mulți Ani!", category: "Cadou", size: "200 g" },
  { name: "Cadou Brăduțul Bucuria", category: "Cadou", size: "300 g" },
  { name: "Cadou Căsuța Bucuriei", category: "Cadou", size: "400 g" },
  { name: "Cadou Căluț", category: "Cadou", size: "500 g" },
  { name: "Cadou Lădița Fermecată", category: "Cadou", size: "600 g" },

  { name: "Vin Spumant J'Adore Blanc de Blancs", category: "Vin spumant", size: "750 ml", pack: "6/bax" },
  { name: "Vin Spumant J'Adore Cuvée Brut", category: "Vin spumant", size: "750 ml", pack: "6/bax" },
  { name: "Vin Spumant J'Adore Muscat Blanc", category: "Vin spumant", size: "750 ml", pack: "6/bax" },
  { name: "Vin Spumant J'Adore Muscat Rose", category: "Vin spumant", size: "750 ml", pack: "6/bax" },
  { name: "Vin demisec alb Muscat J'Adore", category: "Vin alb", size: "750 ml", pack: "6/bax" },
  { name: "Vin alb sec J'Adore Wine Cuvée Blanc", category: "Vin alb", size: "750 ml", pack: "6/bax" },
  { name: "Vin roșu sec J'Adore Cuvée Rouge", category: "Vin roșu", size: "750 ml", pack: "6/bax" },
  { name: "Vin demisec roșu Saperavi „J'Adore\"", category: "Vin roșu", size: "750 ml", pack: "6/bax" },
  { name: "Vin demidulce roz Rosé „J'Adore\"", category: "Vin rosé", size: "750 ml", pack: "6/bax" },
];

export const products = raw.map((p, i) => ({
  id: `p-${i + 1}`,
  ...p,
  image: tileFor(i),
}));

export const categories = [
  "Toate",
  "Marinată",
  "Legume conservate",
  "Conserve",
  "Biscuiți",
  "Fursecuri",
  "Cornulețe",
  "Turtă dulce",
  "Bomboane",
  "Caramele",
  "Halva",
  "Zefir",
  "Vafe",
  "Torturi",
  "Prăjituri",
  "Chec",
  "Croissant",
  "Pliculețe",
  "Nuci",
  "Jeleuri",
  "Desert",
  "Cadou",
  "Vin spumant",
  "Vin alb",
  "Vin roșu",
  "Vin rosé",
  "Băuturi",
  "Sucuri naturale",
  "Șervețele umede",
];
